// The words a column header uses: its screen-reader name, its sort tooltip and its sort failure.

const TEXT_WORDS = ['A-Z', 'Z-A']
const TYPE_WORDS = {
  numeric: ['Lowest first', 'Highest first'],
  date: ['Oldest first', 'Newest first'],
}

const isWord = word => typeof word === 'string' && word.trim() !== ''

// A column with a declared sort order may name its own two directions as sortWords: [ascending, descending].
const declaredWords = column =>
  Array.isArray(column.sortWords) &&
  column.sortWords.length === 2 &&
  column.sortWords.every(isWord)
    ? column.sortWords
    : null

/** @returns {[string, string]} the ascending and descending words */
export const sortWords = column =>
  declaredWords(column) || TYPE_WORDS[column.type] || TEXT_WORDS

// An actions column and a column that declares headerHidden show no visible header text.
export const isHeaderHidden = column =>
  column.type === 'actions' || column.headerHidden === true

/** The column's name for assistive technology, never empty. */
export const columnName = column =>
  column.label || (column.type === 'actions' ? 'Actions' : column.key)

/**
 * Unsorted: "Order by <name>". Sorted: the current order's words, prefixed with the full name while the
 * visible label is truncated.
 */
export const sortTooltip = (column, direction, truncated = false) => {
  if (direction !== 'ascending' && direction !== 'descending')
    return `Order by ${columnName(column)}`
  const words = sortWords(column)[direction === 'ascending' ? 0 : 1]
  return truncated ? `${columnName(column)}, ${words}` : words
}

/** What the shared sort header announces if a sort request fails. */
export const sortFailureLabel = column =>
  `Could not sort by ${columnName(column)}`
